export const sqaPageBannerArabic = {
    mainHeading: "خدمة ضمان",
    greenHeading: "جودة البرمجيات",
    subHeadingGreen: "موثوق بها من قبل الشركات الناشئة والشركات الصغيرة والمتوسطة والمؤسسات على حد سواء",
    sectionDescription: "لا تسبب خدمات ضمان جودة البرمجيات لدينا أي عوائق في الإصدار، بل تعزز دورة التطوير بأكملها من البداية.",
    buttonText: "هيا بنا نبدأ"
}

export const SaqDevelopmentServicesDataArabic = {
    sectionContent: {
        mainHeading: "مجموعتنا الشاملة من خدمات ضمان جودة البرمجيات.",
        sectionDescription: "تغطي خدمات تطبيقات الويب لدينا كل شيء بدءًا من منصات السحابة المخصصة والبوابات التفاعلية إلى تطوير الواجهة الأمامية السلسة والواجهة الخلفية القوية. نحن نقدم حلولًا آمنة وقابلة للتطوير مصممة لتتطور مع عملك، بما في ذلك استشارات الخبراء وتطوير التجارة الإلكترونية."
    },

    tabsData: [
        {
            id: "Tab1",
            label: "اختبار وضمان جودة بوابة الويب",
            content:
                "تعد بوابة الويب الخالية من العيوب أمرًا بالغ الأهمية لتجربة مستخدم سلسة. تركز خدمات ضمان الجودة الشاملة لدينا على الأداء والأمان والوظائف لضمان تشغيل بوابتك بكفاءة دون مشاكل.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/software-quality-assurance/Apache_JMeter.png",
                },
                {
                    img: "/images/services-icons/software-quality-assurance/Postman_(software).png",
                },
                {
                    img: "/images/services-icons/software-quality-assurance/Selenium_logo.png",
                },
            ],
        },
        {
            id: "Tab2",
            label: "اختبار ضمان الجودة والأمان للواجهة الخلفية",
            content:
                "نقوم بإجراء اختبار صارم للواجهة الخلفية لضمان أن البنية التحتية لبوابة الويب الخاصة بك آمنة وقابلة للتطوير وخالية من نقاط الضعف. يتضمن اختبار الأمان لدينا اختبار الاختراق، وفحوصات سلامة قاعدة البيانات، والتحقق من أمان API، وتحليل أداء جانب الخادم لمنع التهديدات السيبرانية وضمان الأداء السلس.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/software-quality-assurance/Apache_JMeter.png",
                },
                {
                    img: "/images/services-icons/software-quality-assurance/Postman_(software).png",
                },
                {
                    img: "/images/services-icons/software-quality-assurance/Selenium_logo.png",
                },
            ],
        },
        {
            id: "Tab3",
            label: "اختبار الواجهة الأمامية والتحقق من واجهة المستخدم/تجربة المستخدم",
            content:
                "تعد الواجهة الأمامية المُحسّنة جيدًا مفتاح مشاركة المستخدم والاحتفاظ به. يقوم فريقنا بإجراء التحقق من واجهة المستخدم/تجربة المستخدم، واختبار الاستجابة، وفحوصات التوافق عبر المتصفحات لضمان أن بوابتك تقدم تجربة بديهية، وسهلة الوصول، وجذابة بصريًا عبر جميع الأجهزة والأنظمة الأساسية.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/software-quality-assurance/Apache_JMeter.png",
                },
                {
                    img: "/images/services-icons/software-quality-assurance/Postman_(software).png",
                },
                {
                    img: "/images/services-icons/software-quality-assurance/Selenium_logo.png",
                },
            ],
        },
        {
            id: "Tab4",
            label: "استشارات ضمان جودة تطبيقات الويب",
            content:
                "نحن نقدم استشارات ضمان الجودة لمساعدة الشركات على تنفيذ استراتيجيات اختبار فعالة، وأطر عمل الأتمتة، وعمليات مراقبة الجودة. تضمن خبرتنا التزام تطبيقات الويب الخاصة بك بمعايير الصناعة وأفضل الممارسات، مما يقلل من الأخطاء، ووقت التوقف عن العمل، واختناقات الأداء.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/software-quality-assurance/Apache_JMeter.png",
                },
                {
                    img: "/images/services-icons/software-quality-assurance/Postman_(software).png",
                },
                {
                    img: "/images/services-icons/software-quality-assurance/Selenium_logo.png",
                },
            ],
        },
        {
            id: "Tab5",
            label: "اختبار البرامج المخصص للمؤسسات",
            content:
                "تتطلب تطبيقات المؤسسات اختبارًا متخصصًا للتعامل مع حركة المرور العالية، وسير العمل المعقدة، والتكاملات المتعددة. تشمل حلول ضمان الجودة المخصصة لدينا اختبار الأداء، وتقييمات قابلية التوسع، والتحقق من الامتثال، والمراقبة في الوقت الفعلي لضمان استمرارية الأعمال.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/software-quality-assurance/Apache_JMeter.png",
                },
                {
                    img: "/images/services-icons/software-quality-assurance/Postman_(software).png",
                },
                {
                    img: "/images/services-icons/software-quality-assurance/Selenium_logo.png",
                },
            ],
        },
        {
            id: "Tab6",
            label: "أنظمة إدارة المحتوى بلا رأس (Headless CMS) واختبار ضمان الجودة لـ WordPress",
            content:
                "بالنسبة للشركات التي تعتمد على المحتوى، نقدم اختبارًا شاملاً لمنصات Headless CMS و WordPress. تتضمن عمليتنا فحوصات توافق الإضافات، والتحقق من تحسين محركات البحث (SEO)، وتحسين السرعة، ومراجعات الأمان لتعزيز تسليم المحتوى، وتصنيفات البحث، والأداء العام.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/software-quality-assurance/Apache_JMeter.png",
                },
                {
                    img: "/images/services-icons/software-quality-assurance/Postman_(software).png",
                },
                {
                    img: "/images/services-icons/software-quality-assurance/Selenium_logo.png",
                },
            ],
        },
    ]
}

export const sqaTypesOfBuildDataArabic = {
    mainHeading: "أنواع اختبار البرامج التي نقدمها",
    accordianData: [
        {
            id: "collapseOne",
            question: "الاختبار الآلي",
            answer: {
                discription:
                    "يعمل الاختبار الآلي على تسريع عملية ضمان الجودة، حيث يقوم بتشغيل آلاف حالات الاختبار على الفور لاكتشاف الأخطاء قبل الإطلاق. من خلال الاستفادة من الأتمتة، نضمن جودة متسقة، ونقلل الجهد اليدوي مع تعزيز أداء البرامج وأمانها وموثوقيتها لتجارب مستخدم سلسة.",
                listTitle: "خدمات الاختبار الآلي لدينا هي الأفضل لـ:",
                listContent: [
                    {
                        line: "تطبيقات المؤسسات واسعة النطاق",
                    },
                    {
                        line: "تحديثات وإصدارات البرامج المتكررة",
                    },
                    {
                        line: "تحسين الأداء واختبار الإجهاد",
                    },
                    {
                        line: "تحديد نقاط الضعف الأمنية",
                    },
                    {
                        line: "تعزيز الدقة بأقل جهد يدوي",
                    },
                ],
            },
        },
        {
            id: "collapseTwo",
            question: "الاختبار اليدوي",
            answer: {
                discription:
                    "أحيانًا، لا يمكن إلا للعين البشرية اكتشاف المشكلات الدقيقة! يحاكي خبراؤنا في الاختبار اليدوي سيناريوهات العالم الحقيقي، مما يضمن أن يكون البرنامج بديهيًا ومتجاوبًا وسهل الاستخدام. نتعمق في نظامك، ونتأكد من عدم تسرب أي خطأ، ونقدم تجربة مستخدم مصقولة وخالية من العيوب.",
                listTitle: "خدمات الاختبار اليدوي لدينا هي الأفضل لـ:",
                listContent: [
                    {
                        line: "اختبار قابلية الاستخدام والاختبار الاستكشافي",
                    },
                    {
                        line: "سير العمل المعقدة ورحلات المستخدم",
                    },
                    {
                        line: "التطبيقات التي تتطلب حكمًا بشريًا",
                    },
                    {
                        line: "ضمان تصميم واجهة المستخدم/تجربة المستخدم البديهي",
                    },
                    {
                        line: "تحديد الأخطاء الحافة",
                    },
                ],
            },
        },
        {
            id: "collapseThree",
            question: "اختبار الأداء",
            answer: {
                discription:
                    "التطبيق البطيء يبعد المستخدمين! نحن نختبر برامجك تحت ضغط العالم الحقيقي - محاكاة حركة المرور العالية، وأحمال الإجهاد، والظروف القاسية لضمان أداء سلس وخالٍ من التأخير. يضمن اختبارنا تشغيل حلول برامجك بكفاءة، حتى أثناء فترات الذروة.",
                listTitle: "خدمات اختبار الأداء لدينا هي الأفضل لـ:",
                listContent: [
                    {
                        line: "تطبيقات الويب والجوال ذات حركة المرور العالية",
                    },
                    {
                        line: "موازنة التحميل واختبار قابلية التوسع",
                    },
                    {
                        line: "ضمان أوقات استجابة سريعة",
                    },
                    {
                        line: "التطبيقات التي تتعامل مع معالجة البيانات في الوقت الفعلي",
                    },
                    {
                        line: "تحديد اختناقات الأداء",
                    },
                ],
            },
        },
        {
            id: "fourth",
            question: "اختبار الأمان",
            answer: {
                discription:
                    "التهديدات السيبرانية حقيقية - ونحن نضمن تحصين برامجك ضدها. يكشف اختبار الأمان لدينا عن نقاط الضعف ويصلحها قبل أن يتمكن المتسللون من ذلك، مما يحمي البيانات الحساسة وخصوصية المستخدم وسلامة العمل. من اختبار الاختراق إلى فحوصات الامتثال، لدينا تغطية أمنية كاملة.",
                listTitle: "خدمات اختبار الأمان لدينا هي الأفضل لـ:",
                listContent: [
                    {
                        line: "حماية بيانات العملاء الحساسة",
                    },
                    {
                        line: "المعاملات التجارية والمالية الإلكترونية",
                    },
                    {
                        line: "الامتثال لمعايير الأمان (ISO, GDPR)",
                    },
                    {
                        line: "تقييمات الضعف والاختراق الأخلاقي",
                    },
                    {
                        line: "منع الوصول غير المصرح به والتهديدات",
                    },
                ],
            },
        },
        {
            id: "fifth",
            question: "اختبار التوافق",
            answer: {
                discription:
                    "يجب أن يعمل برنامجك بسلاسة في كل مكان! سواء كان iOS أو android أو Windows أو Mac أو الأجهزة القابلة للارتداء، فإن اختبار التوافق لدينا يضمن تجربة سلسة عبر جميع الأنظمة الأساسية والمتصفحات والأجهزة. بغض النظر عن مكان وجود المستخدمين، يظل برنامجك سلسًا ويمكن الوصول إليه.",
                listTitle: "خدمات اختبار التوافق لدينا هي الأفضل لـ:",
                listContent: [
                    {
                        line: "تطبيقات الجوال والكمبيوتر المكتبي متعددة المنصات",
                    },
                    {
                        line: "ضمان توافق المتصفح ونظام التشغيل",
                    },
                    {
                        line: "تطبيقات الويب المتجاوبة",
                    },
                    {
                        line: "الأجهزة القابلة للارتداء وأجهزة إنترنت الأشياء",
                    },
                    {
                        line: "الاتساق عبر الأجهزة",
                    },
                ],
            },
        },
        {
            id: "sixth",
            question: "اختبار الانحدار",
            answer: {
                discription:
                    "يجب أن يؤدي كل تحديث إلى تحسين تطبيقك، وليس تعطيله! يضمن اختبار الانحدار لدينا أنه عند طرح ميزات جديدة، لا يزال كل شيء يعمل بشكل مثالي. نقوم بإعادة اختبار الوظائف الأساسية، مما يضمن بقاء التحديثات والتكاملات السابقة سليمة وموثوقة، مما يمنع الأعطال غير المتوقعة.",
                listTitle: "خدمات اختبار الانحدار لدينا هي الأفضل لـ:",
                listContent: [
                    {
                        line: "تحديثات وتحسينات البرامج المستمرة",
                    },
                    {
                        line: "اختبار الميزات الجديدة دون تعطيل الميزات القديمة",
                    },
                    {
                        line: "الأنظمة المعقدة ذات التكاملات المتعددة",
                    },
                    {
                        line: "دورات تطوير Agile سريعة الوتيرة",
                    },
                    {
                        line: "منع المشكلات بعد الإصدار",
                    },
                ],
            },
        },
    ]
}

export const sqaWhoWeServeDataArabic = {
    sectionContent: {
        mainHeading: "من نخدم",
        sectionDescription: "نحن نساعد الشركات بجميع أحجامها على تحقيق أداء برمجي لا تشوبه شائبة من خلال خدمات ضمان جودة البرمجيات الشاملة. سواء كنت شركة ناشئة تطلق منتجًا جديدًا، أو شركة برمجيات توسع نطاق منصتها، أو مؤسسة تتطلب حلول اختبار واسعة النطاق، يضمن خبراء ضمان الجودة لدينا برمجيات خالية من الأخطاء وعالية الأداء وآمنة."
    },
    cardsData: [
        {
            icon: "/images/servie-icon/startups.svg",
            title: "الشركات الناشئة",
            description:
                "اختبار من الألف إلى الياء لضمان أن يكون منتجك الأولي (MVP) أو إصدارك الأول سلسًا وعمليًا وسهل الاستخدام. تساعد خدمات ضمان الجودة لدينا الشركات الناشئة على تحديد المشكلات المحتملة قبل الإطلاق، مما يضمن تجربة سلسة للمستخدمين الأوائل.",
            link: "#",
            borderClass: "border-1",
        },
        {
            icon: "/images/servie-icon/company.png",
            title: "شركات المنتجات البرمجية",
            description:
                "تتطلب شركات البرمجيات اختبارًا مستمرًا مع نمو منصاتها. نحن نقدم خدمات ضمان الجودة المستمرة لتحديد الأخطاء ومشكلات التوافق ونقاط الضعف الأمنية، مما يضمن أن حلول برامجك تعمل على النحو الأمثل عبر جميع الإصدارات والتحديثات.",
            link: "#",
            borderClass: "border-2",
        },
        {
            icon: "/images/servie-icon/industries.svg",
            title: "المؤسسات من 30+ صناعة",
            description:
                "تتطلب الشركات الكبيرة ضمان جودة برمجيات قويًا للحفاظ على الامتثال والأمان والأداء عبر الأنظمة المعقدة. نحن نضمن بقاء برامج المؤسسات آمنة وقابلة للتطوير وفعالة مع تقليل وقت التوقف عن العمل والمخاطر.",
            link: "#",
            borderClass: "border-3",
        },
    ]
}

export const sqaWhyChooseBitsclanDataArabic = {
    sectionContent: {
        mainHeading: "لماذا تختار بيتسكلان كشركة لخدمات ضمان الجودة؟",
        sectionDescription: "في بيتسكلان، نقدم ضمان جودة شامل للبرمجيات، مما يضمن أن تطبيقاتك خالية من الأخطاء، وقابلة للتطوير، وآمنة. يركز خبراء ضمان الجودة لدينا على الوظائف السلسة، والأتمتة، واختبار الأداء لضمان تلبية برامجك لمعايير الصناعة وتوقعات المستخدمين. من الاختبار الآلي إلى التقييمات اليدوية، نقوم بتخصيص حلول ضمان الجودة للحفاظ على برامجك في أفضل حالاتها."
    },
    tabsData: [
        {
            id: "Tab1",
            label: "الجودة لأنها مهمة",
            content:
                "في بيتسكلان، الجودة ليست مجرد هدف - إنها معيار متأصل في كل مرحلة من دورة حياة التطوير. نعتمد استراتيجية شاملة لضمان الجودة تتضمن الاختبار الوظيفي، واختبار الانحدار، واختبار قابلية الاستخدام، واختبار الأداء، واختبار التوافق.",
            content2:
                "تستخدم فرق ضمان الجودة المتخصصة لدينا أدوات رائدة في الصناعة وأفضل الممارسات لضمان أن كل منتج نقدمه يلبي أعلى معايير الأداء والأمان وتجربة المستخدم. من خلال اكتشاف المشكلات وحلها مبكرًا، نساعدك على تجنب الانتكاسات المكلفة وتقديم حلول قوية وخالية من الأخطاء تبني الثقة مع المستخدمين.",
            btnText: "تواصل مع فريقنا",
            btnLink: "#",
        },
        {
            id: "Tab2",
            label: "أفضل المواهب من نوعها",
            content:
                "يتم اختيار خبراء ضمان الجودة لدينا بعناية من بين أفضل المتخصصين في الصناعة، مما يجلب سنوات من الخبرة المتخصصة والتزامًا لا يتزعزع بالتميز. يتمتع كل عضو في فريقنا بالمهارة في مجموعة واسعة من منهجيات الاختبار - من الاختبار الاستكشافي اليدوي إلى مجموعات الاختبار الآلية بالكامل.",
            content2:
                "بفضل الأساس القوي في سير عمل Agile وخطوط أنابيب CI/CD، يعمل متخصصو ضمان الجودة لدينا بشكل وثيق مع فريق التطوير الخاص بك لضمان أن تطبيقاتك فعالة وقابلة للتطوير ومتوافقة مع أهداف عملك. نحن لا نختبر البرامج فحسب - بل نحسنها.",
            btnText: "تواصل مع فريقنا",
            btnLink: "#",
        },
        {
            id: "Tab3",
            label: "توافق المنطقة الزمنية",
            content:
                "يطالب العملاء العالميون بتعاون سلس، وهذا بالضبط ما نقدمه. يتم توزيع فريقنا بشكل استراتيجي وهو قادر تمامًا على التوافق مع ساعات العمل المفضلة لديك، مما يضمن تحديثات في الوقت المناسب، وحلقات تغذية راجعة سريعة، وتتبعًا ثابتًا للتقدم.",
            content2:
                "سواء كنت في أمريكا الشمالية أو أوروبا أو الشرق الأوسط أو منطقة آسيا والمحيط الهادئ، فإننا نتكيف مع جدولك الزمني ونضمن التواصل الشفاف في الوقت الفعلي. مع بيتسكلان، لم تعد المناطق الزمنية حاجزًا - إنها جسر للإنتاجية والتعاون.",
            btnText: "تواصل مع فريقنا",
            btnLink: "#",
        },
        {
            id: "Tab4",
            label: "الأتمتة من أجل اختبار أسرع",
            content:
                "في بيئة التطوير سريعة الوتيرة اليوم، السرعة والدقة غير قابلتين للتفاوض. تم تصميم خدمات اختبار الأتمتة لدينا لتقليل الجهد اليدوي بشكل كبير وزيادة تغطية الاختبار عبر تطبيقك.",
            content2:
                "نحن نستفيد من الأدوات المتقدمة مثل Selenium و Appium و Cypress لبناء نصوص اختبار موثوقة وقابلة لإعادة الاستخدام. من اختبار الانحدار إلى التحقق من الأداء، يضمن نهج الأتمتة لدينا إمكانية النشر بثقة والتوسع بسرعة.",
            btnText: "تواصل مع فريقنا",
            btnLink: "#",
        },
        {
            id: "Tab5",
            label: "اختبار الأمان لحماية البيانات",
            content:
                "الأمن السيبراني أولوية قصوى في العصر الرقمي، وتعكس استراتيجية ضمان الجودة لدينا ذلك. نحن نقدم خدمات اختبار أمان قوية تكشف نقاط الضعف وتمنع الوصول غير المصرح به إلى تطبيقاتك.",
            content2:
                "تتضمن عمليتنا اختبار الاختراق، ونمذجة التهديدات، وفحوصات الامتثال التي تساعد على حماية البيانات الحساسة وضمان الامتثال التنظيمي. من خلال المعالجة الاستباقية للمخاطر المحتملة، نحمي عملك وثقة المستخدم.",
            btnText: "تواصل مع فريقنا",
            btnLink: "#",
        },
    ]
}

export const sqaHighvaluesDataArabic = {
    mainHeading: "ميزات عالية القيمة لخدمات ضمان الجودة عالية الأداء",
    sectionDescription: "تضمن خدمات ضمان الجودة لدينا أن برنامجك يلبي أعلى معايير الصناعة مع وظائف سلسة وأمان وكفاءة. نركز على الاختبار الشامل والأتمتة والمراقبة في الوقت الفعلي لتقديم تطبيقات خالية من الأخطاء وقابلة للتطوير وعالية الأداء.",
    buttonText: "استشر نطاق المشروع",
    cardsData: [
        {
            image: "qa-icon-1.svg",
            text: "الاختبار الآلي",
        },
        {
            image: "qa-icon-2.svg",
            text: "الاختبار اليدوي",
        },
        {
            image: "qa-icon-3.svg",
            text: "اختبار الأداء",
        },
        {
            image: "qa-icon-4.svg",
            text: "اختبار الأمان",
        },
        {
            image: "qa-icon-5.svg",
            text: "الاختبار الوظيفي",
        },
        {
            image: "qa-icon-6.svg",
            text: "اختبار الانحدار",
        },
        {
            image: "qa-icon-7.svg",
            text: "اختبار قابلية الاستخدام",
        },
        {
            image: "qa-icon-8.svg",
            text: "اختبار التوافق",
        },
        {
            image: "qa-icon-9.svg",
            text: "اختبار التحميل والضغط",
        },
        {
            image: "qa-icon-10.svg",
            text: "تتبع الأخطاء والإبلاغ عنها",
        },
    ]
}

export const sqaRoadMapDataArabic = {
    heading: "خارطة طريقنا المثبتة لتقديم ضمان جودة برامج لا تشوبه شائبة",
    description:
        "ضمان تشغيل برامجك بسلاسة هو أولويتنا القصوى. نحن نتبع خارطة طريق منظمة لضمان الجودة مصممة لتحديد العيوب ومنعها وحلها بكفاءة. من التخطيط الأولي إلى التحسين المستمر، نتأكد من أن برنامجك يلبي معايير الجودة العالية، وخالٍ من الأخطاء، ويعمل بشكل لا تشوبه شائبة عبر جميع الأنظمة الأساسية. إليك كيفية ضمان التميز:",
    roadMapsteps: [
        "نتعمق في بنية برنامجك، ونحدد أهداف الاختبار، ونضع استراتيجية ضمان الجودة التي تضمن وظائف سلسة.",
        "يختبر خبراء ضمان الجودة لدينا بدقة الوظائف والأداء والأمان والتوافق، مما يضمن أن برنامجك يلبي معايير جودة الصناعة.",
        "نحن نقدم اختبارًا مستمرًا، وحل المشكلات في الوقت الفعلي، وتحسينات الجودة للحفاظ على استقرار البرامج وأمانها وموثوقيتها.",
        "نقوم بتصميم إطار عمل اختبار مخصص، واختيار مناهج الاختبار الآلي واليدوي الصحيحة لضمان الكفاءة والأداء العالي.",
    ],
    roadMapHeading: [
        "",
        "التنفيذ والتطبيق",
        "المراقبة والتحسين",
        "استراتيجية الاختبار وإثبات المفهوم",
    ],
};

export const sqaCoverTheStackArabic = {
    mainHeading: "عزز ضمان الجودة لديك باستخدام حزمة تقنية قوية",
    sectionDescription: "في بيتسكلان، نستفيد من التقنيات الرائدة في الصناعة لضمان أعلى مستوى من جودة البرمجيات. تعمل حزمتنا التقنية المتقدمة على تحسين عمليات الاختبار، وتعزيز الأتمتة، وضمان الأداء السلس والأمان وقابلية التوسع طوال دورة حياة تطوير البرامج.",
    defaultTabOpen: "أدوات أتمتة الاختبار",

    tabs: [
        "أدوات أتمتة الاختبار",
        "أدوات إدارة الاختبار أو العيوب",
        "أدوات التوثيق",
        "أدوات الاختبار",
    ],

    tabItems: [
        { tab: "أدوات أتمتة الاختبار", icon: "/images/tech-stack-icons/selenium.svg", name: "Selenium" },
        { tab: "أدوات أتمتة الاختبار", icon: "/images/tech-stack-icons/cypress.svg", name: "Cypress" },
        { tab: "أدوات أتمتة الاختبار", icon: "/images/tech-stack-icons/playwright.svg", name: "Playwright" },
        { tab: "أدوات أتمتة الاختبار", icon: "/images/tech-stack-icons/test-io.svg", name: "Test.io" },
        { tab: "أدوات أتمتة الاختبار", icon: "/images/tech-stack-icons/cucumber.svg", name: "Cucumber" },
        { tab: "أدوات أتمتة الاختبار", icon: "/images/tech-stack-icons/postman.svg", name: "Postman" },
        { tab: "أدوات أتمتة الاختبار", icon: "/images/tech-stack-icons/browserstack.svg", name: "Browserstack" },
        { tab: "أدوات أتمتة الاختبار", icon: "/images/tech-stack-icons/cicd.svg", name: "Ci/Cd" },

        { tab: "أدوات إدارة الاختبار أو العيوب", icon: "/images/tech-stack-icons/jira.svg", name: "Jira" },
        { tab: "أدوات إدارة الاختبار أو العيوب", icon: "/images/tech-stack-icons/trello.svg", name: "Trello" },
        { tab: "أدوات إدارة الاختبار أو العيوب", icon: "/images/tech-stack-icons/asana.svg", name: "Asana" },
        { tab: "أدوات إدارة الاختبار أو العيوب", icon: "/images/tech-stack-icons/bugzilla.svg", name: "Bugzilla" },
        { tab: "أدوات إدارة الاختبار أو العيوب", icon: "/images/tech-stack-icons/open-project.svg", name: "OpenProject" },
        { tab: "أدوات إدارة الاختبار أو العيوب", icon: "/images/tech-stack-icons/testrail.svg", name: "Testrail" },
        { tab: "أدوات إدارة الاختبار أو العيوب", icon: "/images/tech-stack-icons/click-up.svg", name: "Clickup" },

        { tab: "أدوات التوثيق", icon: "/images/tech-stack-icons/notion.svg", name: "Notion" },
        { tab: "أدوات التوثيق", icon: "/images/tech-stack-icons/jira-confluence.svg", name: "Jira-Confluence " },

        { tab: "أدوات الاختبار", icon: "/images/tech-stack-icons/excel.svg", name: "Excel" },
        { tab: "أدوات الاختبار", icon: "/images/tech-stack-icons/word.svg", name: "Word" },
        { tab: "أدوات الاختبار", icon: "/images/tech-stack-icons/apache.svg", name: "Apache Jmeter" },
        { tab: "أدوات الاختبار", icon: "/images/tech-stack-icons/postman.svg", name: "Postman" },
        { tab: "أدوات الاختبار", icon: "/images/tech-stack-icons/swagger.svg", name: "Swagger" },
    ]
}

export const sqaIndustriesHeadingArabic = {
    mainHeading: "الصناعات التي نخدمها في ضمان جودة البرمجيات"
}

export const sqaFaqDataArabic = {
    mainHeading: "الأسئلة الشائعة",
    sectionDescription: "احصل على إجابات سريعة لأسئلتك حول عملية وخدمات تطوير تطبيقات الهاتف المحمول لدينا.",
    questionAnswer: [
        {
            id: "collapseOne",
            question: "ما هو ضمان جودة البرمجيات (QA) ولماذا هو مهم؟",
            answer:
                "يضمن ضمان جودة البرمجيات (QA) أن تطبيقك يعمل بشكل صحيح، ويلبي توقعات المستخدمين، ويتوافق مع معايير الصناعة. باستخدام كل من الاختبار الآلي واليدوي، تحدد خدمات ضمان الجودة المشكلات المحتملة في وقت مبكر من عملية التطوير، مما يوفر الوقت والتكلفة مع ضمان منتجات موثوقة وعالية الجودة.",
        },
        {
            id: "collapseTwo",
            question: "ما هو الفرق بين الاختبار الآلي والاختبار اليدوي؟",
            answer:
                "يستخدم الاختبار الآلي النصوص البرمجية والأدوات لإجراء الاختبارات بسرعة وبشكل متكرر، مما يجعله مثاليًا لاختبارات الانحدار والأنظمة واسعة النطاق. من ناحية أخرى، يتضمن الاختبار اليدوي مختبرين بشريين يستكشفون التطبيقات للعثور على سلوك غير متوقع ومشكلات قابلية الاستخدام التي قد يفوتها الاختبار الآلي. كلاهما حاسم لتقديم برامج عالية الجودة.",
        },
        {
            id: "collapseThree",
            question: "ما أنواع خدمات ضمان الجودة التي تقدمونها؟",
            answer:
                "نحن نقدم مجموعة كاملة من خدمات ضمان جودة البرمجيات، بما في ذلك الاختبار الآلي، والاختبار اليدوي، واختبار الأداء، واختبار الأمان، واستشارات ضمان الجودة. سواء كنت تطلق تطبيق جوال أو منصة ويب معقدة، فإننا نضمن أن كل شيء يعمل بسلاسة وأمان لمستخدميك.",
        },
        {
            id: "fourth",
            question: "كيف يمكن لاستشارات ضمان الجودة مساعدة عملي؟",
            answer:
                "توجه خدمات استشارات ضمان الجودة لدينا فريقك عبر أفضل الممارسات في اختبار البرامج. نقوم بتحليل عملياتك الحالية، ونوصي بالتحسينات، ونساعد في تنفيذ استراتيجيات الاختبار التي تتناسب مع الاحتياجات المحددة لمشروعك. هدفنا هو ضمان أن برنامجك يلبي جميع معايير الوظائف والأمان وتجربة المستخدم.",
        },
        {
            id: "fifth",
            question: "هل خدمة ضمان الجودة الخاصة بكم متوافقة مع جميع أنواع البرامج؟",
            answer:
                "نعم، نحن نقدم خدمات ضمان الجودة لجميع أنواع البرامج - سواء كانت تطبيقات جوال أو تطبيقات ويب أو أنظمة مؤسسية. يتمتع فريقنا بخبرة عبر مختلف الصناعات، مما يضمن اختبار حل برامجك بدقة، من الوظائف إلى تجربة المستخدم والأمان.",
        },
        {
            id: "sixth",
            question: "لماذا يجب أن أستثمر في خدمات ضمان الجودة لمشروع البرمجيات الخاص بي؟",
            answer:
                "يساعدك الاستثمار في خدمات ضمان الجودة على اكتشاف المشكلات المحتملة قبل أن تصل إلى عملائك، مما يضمن تجارب مستخدم سلسة ويقلل من مخاطر الأخطاء المكلفة. بمساعدة الاختبار الآلي واليدوي، نساعدك على إنشاء منتج عالي الأداء وآمن وسهل الاستخدام.",
        },
        {
            id: "seventh",
            question: "كيف يمكنني البدء بخدمات ضمان الجودة الخاصة بكم؟",
            answer:
                "البدء سهل! ما عليك سوى التواصل معنا، وسيقوم خبراؤنا بتقييم مشروعك والتوصية بأفضل استراتيجية لضمان الجودة. سنرشدك خلال مراحل الاختبار ونساعد في ضمان أن برنامجك يلبي جميع المعايير اللازمة لإطلاق ناجح. دعنا نعمل معًا لتقديم حلول عالية الجودة!",
        },
    ]
}